import { Box, CircularProgress, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'

const FullPageLoader = ({
    message = 'Loading...',
    hideBackdrop = false
}: {
    message?: ReactNode
    hideBackdrop?: boolean
}) => {
    const t = useTranslations('common')
    const displayMessage = message || t('loading')
    return (
        <Box
            sx={{
                // Full viewport overlay
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: '100dvw',
                height: '100dvh',
                zIndex: 1300, // Same as Material-UI Dialog z-index

                // Backdrop styling
                backgroundColor: hideBackdrop ? '#fff' : 'rgba(0, 0, 0, 0.5)',

                // Center content
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',

                // Prevent scrolling behind the loader
                overflow: 'hidden'
            }}
        >
            {/* Content container - mimics DialogContent */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    padding: 3,
                    margin: 3,

                    // Paper-like styling when backdrop is visible
                    ...(!hideBackdrop && {
                        backgroundColor: 'background.paper',
                        borderRadius: 1,
                        boxShadow: 24,
                        minWidth: 300,
                        maxWidth: 'lg'
                    }),

                    // Transparent styling when backdrop is hidden
                    ...(hideBackdrop && {
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    })
                }}
            >
                <CircularProgress size={40} sx={{ color: 'brand.primary' }} />
                {typeof displayMessage === 'string' ? (
                    <Typography variant="body1" sx={{ color: 'text.primary', textAlign: 'center' }}>
                        {displayMessage}
                    </Typography>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        {displayMessage}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default FullPageLoader
